export default {
	data() {
		return {
			project: {}
		}
	},
	methods: {
		createProjectPromise() {
			return this.$http.post(
				this.$store.getters.endpoint + '/db/projects', {
					login: this.$store.getters.currentUser.login,
					project: this.project
				}, {
					headers: this.$store.state.restrictedHeaders
				}
			)
		},
		updateProjectPromise() {
			return this.$http.put(
				this.$store.getters.endpoint + '/db/projects', {
					login: this.$store.getters.currentUser.login,
					project: this.project
				}, {
					headers: this.$store.state.restrictedHeaders
				}
			)
		},
		deleteProjectPromise() {
			return this.$http.patch(
				this.$store.getters.endpoint + '/db/projects', {
					login: this.$store.getters.currentUser.login,
					project: this.project.project_id
				}, {
					headers: this.$store.state.restrictedHeaders
				}
			)
		},
		getProjectPropertyPromise(type) {
			const cleanedProject = Object.keys(this.project)
				.filter(key => [
					'project_name', 'project_table', 'dataset_name',
					'mode_notifications', 'mode_persons', 'mode_reports', 'mode_statplaces'
				].includes(key))
				.reduce((obj, key) => {
				    obj[key] = this.project[key];
				    return obj;
				}, {});
			return this.$http.get(
				`${this.$store.getters.endpoint}/db/project/${this.project.project_id}/${type}`, {
					emulateJSON: true,
					params: {
						login: this.$store.getters.currentUser.login,
						...cleanedProject
					},
					headers: this.$store.state.restrictedHeaders
				}

			)
		}
	}
}
